import {PredictionResponse, RulPredictionResponse} from '@mira/api';

import {isNil} from 'ramda';

import {REPORT_WINDOW_KEY} from '../constants/reportWindow';
import {TransformedPredictionData} from '../schemas';
import {transformPredictions} from '../utils/transformPredictions';

interface UseTransformedPredictionsOptions {
  windowKey?: string;
  filterByWillNeed?: boolean;
  rulResponse?: RulPredictionResponse | null;
}

export function useTransformedPredictions(
  predictionResponse: PredictionResponse | undefined,
  options: UseTransformedPredictionsOptions = {}
): TransformedPredictionData {
  if (isNil(predictionResponse) && isNil(options.rulResponse)) {
    return {
      mainGroups: [],
      totalCategories: 0,
      hasAnyPredictions: false,
    };
  }

  const windowKey = options.windowKey ?? REPORT_WINDOW_KEY;
  const filterByWillNeed = options.filterByWillNeed ?? true;

  return transformPredictions(predictionResponse, windowKey, filterByWillNeed, options.rulResponse);
}
